import React, { FC, useCallback, useMemo } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import ColumnSelector from "@app/component/input/ColumnSelector/ColumnSelector";
import ColumnVisibility from "@app/types/viewModel/ColumnVisibility";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

export interface ColumnPaneProps {
  entityType: EntityTypesSupportedColumnSelection;
  onChange?: (columns: IField["platformName"][]) => void;
  value?: IField["platformName"][];
}

const ColumnPane: FC<ColumnPaneProps> = ({ entityType, onChange, value }) => {
  const fixedFields = useMemo(() => {
    const fieldModel = getFieldModelByEntityType(entityType);
    return fieldModel.fields.filter((field) => field.hasFeature(FieldFeature.ALWAYS_VISIBLE));
  }, [entityType]);

  const columnModel = useMemo(() => {
    const fieldModel = getFieldModelByEntityType(entityType);

    return fieldModel.fields.map((field) => ({
      field,
      visible:
        (field.hasAnyFeature(FieldFeature.ALWAYS_VISIBLE) || value?.includes(field.platformName)) ??
        false,
    }));
  }, [entityType, value]);

  const handleUpdate = useCallback(
    (visibilities: ColumnVisibility[]) => {
      onChange?.(
        visibilities.filter(({ visible }) => visible).map(({ field }) => field.platformName)
      );
    },
    [onChange]
  );

  return (
    <ColumnSelector
      columns={columnModel}
      entityType={entityType}
      fixedFields={fixedFields}
      onUpdate={handleUpdate}
      showCategories
    />
  );
};

export default ColumnPane;
